<template>
	<div style="overflow-x: auto">
		<v-data-table
			mobile-breakpoint="0"
			elevation="0"
			:headers="headers"
			:items="filteredShipments"
			:options.sync="options"
			class="elevation-0">
			<template v-slot:header>
				<tr>
					<th v-for="(header, idx) in headers" :key="`header-${idx}`">
						<v-text-field
							dense
							class="ma-2"
							rounded
							v-model="filter[header.value]"
							placeholder="filter"
							solo-inverted
							hide-details
							flat></v-text-field>
					</th>
				</tr>
			</template>
			<template v-slot:[`item.id`]="{ item }">
				<a
					@click="
						$router.push({
							name: 'ShipmentUpdate',
							params: { id: item.id },
						})
					">
					{{ item.id }}
				</a>
			</template>
			<template v-slot:[`item.senderId`]="{ item }">
				{{ getCustomerName(item.senderId) }}
			</template>
			<template v-slot:[`item.receiverId`]="{ item }">
				{{ getCustomerName(item.receiverId) }}
			</template>
			<template v-slot:[`item.shipmentDate`]="{ item }">
				{{ convertToUsDate(item.shipmentDate) }}
			</template>
			<template v-slot:[`item.shipmentStatusId`]="{ item }">
				{{ getOptionName(item.shipmentStatusId) }}
			</template>
			<template v-slot:[`item.boxWeight`]="{ item }">
				{{ `${item.totalBox}/${item.totalWeight}` }}
			</template>
			<template v-slot:[`item.createdBy`]="{ item }">
				{{ getUserName(item.createdBy) }}
			</template>
			<template v-slot:[`item.invoiceId`]="{ item }">
				<a
					v-if="item.invoiceId"
					@click="
						$router.push({
							name: 'InvoiceUpdate',
							params: { id: item.invoiceId },
						})
					">
					{{ item.invoiceId }}
				</a>
			</template>
		</v-data-table>
	</div>
</template>
<script>
import generalMixin from "@/js/general-mixin";
import eventBus from "@/js/event-bus.js";
export default {
	name: "ShipmentList",
	mixins: [generalMixin],
	props: {
		shipments: {
			type: Array,
			default: () => {
				return [];
			},
		},
		customHeaders: {
			type: Array,
			default: () => {
				return [];
			},
		},
	},
	mounted: function () {
		eventBus.$on("generateCsv", this.generateCsv);
	},
	data() {
		return {
			defaultHeaders: [
				{
					text: "Id",
					align: "start",
					value: "id",
					width: "80",
				},
				{
					text: "Tracking #",
					align: "start",
					value: "mtlTracking",
					width: "100",
				},

				{ text: "Sender", value: "senderId", width: "300" },
				{ text: "Receiver", value: "receiverId", width: "300" },
				{ text: "Description", value: "description", width: "100" },
				{ text: "Box/Weight", value: "boxWeight", width: "100" },
				{ text: "Shipment Date", value: "shipmentDate", width: "100" },
				{
					text: "Shipment Status",
					value: "shipmentStatusId",
					width: "100",
				},
				{
					text: "Created By",
					value: "createdBy",
					width: 120,
				},
				{
					text: "Invoice Id",
					value: "invoiceId",
					width: "100",
				},
			],
		};
	},
	computed: {
		filteredShipments() {
			let shipments = this.shipments;
			for (let key in this.filter) {
				let searchStr = this.filter[key].trim().toLowerCase();
				let header = this.headers.find((header) => header.value == key);
				if (searchStr && searchStr.length) {
					shipments = shipments.filter((e) => {
						let str = this.getDataText(header, e);
						return str
							.toString()
							.trim()
							.toLowerCase()
							.includes(this.filter[key].toLowerCase());
					});
				}
			}
			return shipments;
		},
		filter: {
			get() {
				return this.$store.getters["interactStore/shipmentFilter"];
			},
			set(val) {
				this.$store.commit("interactStore/setShipmentFilter", val);
			},
		},
		options: {
			get() {
				return this.$store.getters["interactStore/shipmentOptions"];
			},
			set(val) {
				this.$store.commit("interactStore/setShipmentOptions", val);
			},
		},
		headerDict() {
			let headerDict = {};
			this.customHeaders.forEach((e) => {
				headerDict[e] = true;
			});
			return headerDict;
		},
		headers() {
			if (this.customHeaders.length == 0) return this.defaultHeaders;
			let headers = this.defaultHeaders.filter(
				(e) => this.headerDict[e.value]
			);
			if (this.headerDict["_amountReceived"]) {
				headers.push({
					text: "Amount Received",
					value: "amountReceived",
				});
			}
			return headers;
		},
	},
	methods: {
		generateCsv() {
			let headerStr =
				"Id;Tracking #;Sender;Receiver;Description;Box/Weight;Shipment Date;Shipment Status;Invoice Id";
			let csvContent = "";
			csvContent += headerStr + "\r\n";
			for (let i = 0; i < this.filteredShipments.length; i++) {
				const shipment = this.filteredShipments[i];
				let rowStr =
					`${shipment.id};${
						shipment.mtlTracking
					};${this.getCustomerName(
						shipment.senderId
					)};${this.getCustomerName(shipment.receiverId)}` +
					`;${shipment.description};${shipment.totalBox}/${
						shipment.totalWeight
					};${this.convertToDate(shipment.shipmentDate, false)}` +
					`;${this.getOptionName(
						shipment.shipmentStatusId
					)};${shipment.invoiceId.toString()}`;
				csvContent += rowStr + "\r\n";
			}
			let blob = new Blob([csvContent], { type: "text/plain" });
			let url = URL.createObjectURL(blob);
			let link = document.createElement("a");
			link.setAttribute("href", url);
			link.setAttribute("download", `shipment-list.csv`);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		getDataText(header, shipment) {
			if (header.value == "id") {
				return shipment.id.toString();
			} else if (header.value == "mtlTracking") {
				return shipment.mtlTracking;
			} else if (header.value == "invoiceId") {
				return shipment.invoiceId.toString();
			} else if (header.value == "senderId") {
				return this.getCustomerName(shipment.senderId);
			} else if (header.value == "receiverId") {
				return this.getCustomerName(shipment.receiverId);
			} else if (header.value == "dateCreated") {
				return this.convertToDate(shipment.dateCreated);
			} else if (header.value == "shipmentDate") {
				return this.convertToDate(shipment.shipmentDate, false);
			} else if (header.value == "description") {
				return shipment.description;
			} else if (header.value == "shipmentStatusId") {
				return this.getOptionName(shipment.shipmentStatusId);
			} else if (header.value == "boxWeight") {
				return `${shipment.totalBox}/${shipment.totalWeight}`;
			} else if (header.value == "createdBy") {
				return this.getUserName(shipment.createdBy);
			}
		},
	},
	destroyed: function () {
		eventBus.$off("generateCsv");
	},
};
</script>
